import React, { useState } from "react";

const InfiniteLoadList = (props) => {
  const [prevScrollPosition, setPrevScrollPosition] = useState(0);

  const {
    error,
    errorMessage,
    loading,
    name,
    noRecordsDisplay,
    page,
    records,
    recordsTotal,
    renderRecords,
    showLoader,
    showLoadMore,
    manualLoad,
    latestRecordRef,
  } = props;

  const fetchMore = records.length < recordsTotal;

  const onScroll = (event) => {
    const isHorizontalScroll = event.target.scrollTop === prevScrollPosition;
    const distanceFromBottom =
      event.target.scrollHeight -
      event.target.clientHeight -
      event.target.scrollTop;
    if (
      !loading &&
      fetchMore &&
      !isHorizontalScroll &&
      distanceFromBottom <= 250
    ) {
      props.getRecords(page + 1);
      setPrevScrollPosition(event.target.scrollTop);
    }
  };

  const loadMoreRecords = () => {
    if (!loading && fetchMore) {
      props.getRecords(page + 1);
      latestRecordRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };

  return (
    <div
      className="infinite-scroll-list"
      onScroll={!manualLoad ? onScroll : undefined}
    >
      {!loading && !records.length ? (
        error ? (
          <p className="text-center">
            {errorMessage || "Something went wrong.  Please try again."}
          </p>
        ) : noRecordsDisplay ? (
          noRecordsDisplay
        ) : (
          <p className="empty-state">
            <i className="material-icons">not_interested</i>
            <span>No {name || "Records"} Found</span>
          </p>
        )
      ) : (
        <div>
          {renderRecords(records)}
          {loading
            ? showLoader && <p className="text-center mt-16">Loading...</p>
            : error && (
                <p className="text-center mt-16">
                  {errorMessage || "Something went wrong. Please try again."}
                </p>
              )}
          <div className="flex flex-justify-center mt-24">
            {manualLoad && showLoadMore && fetchMore && (
              <button className="btn btn-text" onClick={loadMoreRecords}>
                Load More
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default React.memo(InfiniteLoadList);
